import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal", "form", "nameInput"];
  static values = {
    baseUrl: String
  };

  connect() {
    this.handleModalHidden = this.handleModalHidden.bind(this);

    if (this.hasModalTarget) {
      this.modalTarget.addEventListener("hidden.bs.modal", this.handleModalHidden);
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener("hidden.bs.modal", this.handleModalHidden);
    }
  }

  open(event) {
    event.preventDefault();

    const surveyId = event.currentTarget.dataset.surveyId;
    const surveyTitle = event.currentTarget.dataset.surveyTitle;

    this.formTarget.action = this.baseUrlValue.replace(":id", surveyId);
    this.nameInputTarget.value = surveyTitle;

    const modal = new Modal(this.modalTarget);
    modal.show();

    this.modalTarget.addEventListener("shown.bs.modal", () => {
      this.nameInputTarget.focus();
      this.nameInputTarget.select();
    }, { once: true });
  }

  handleModalHidden() {
    this.nameInputTarget.value = "";
  }
}
